"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeclinedPhoto = void 0;
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const UpdateCase_1 = tslib_1.__importDefault(require("./UpdateCase"));
const PhotoType_1 = require("./enums/PhotoType");
const UpdateActions_1 = require("./enums/UpdateActions");
class DeclinedPhoto extends base_models_1.Serializable {
}
exports.DeclinedPhoto = DeclinedPhoto;
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsEnum)(PhotoType_1.PhotoType),
    (0, base_models_1.Docs)({
        description: 'Name of the photo',
        example: PhotoType_1.PhotoType.SmartMeter,
    }),
    (0, class_transformer_1.Expose)({ name: 'type' }),
    tslib_1.__metadata("design:type", String)
], DeclinedPhoto.prototype, "type", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        description: 'Reason why the photo is declined',
        example: 'Photo is not clear',
    }),
    (0, class_transformer_1.Expose)({ name: 'reason' }),
    tslib_1.__metadata("design:type", String)
], DeclinedPhoto.prototype, "reason", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        description: 'S3 document ID of the photo',
        example: 'emobility*account123$12345$essent',
    }),
    (0, class_transformer_1.Expose)({ name: 'document_id' }),
    tslib_1.__metadata("design:type", String)
], DeclinedPhoto.prototype, "documentId", void 0);
class UpdateCaseInternal extends UpdateCase_1.default {
}
exports.default = UpdateCaseInternal;
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({
        description: 'Indicates if the review is done',
        example: true,
    }),
    (0, class_transformer_1.Expose)({ name: 'review_complete' }),
    tslib_1.__metadata("design:type", Boolean)
], UpdateCaseInternal.prototype, "reviewComplete", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        description: 'S3 document ID of uploaded quotation',
        example: 'emobility*account123$12345$essent',
    }),
    (0, class_transformer_1.Expose)({ name: 'quotation_document' }),
    tslib_1.__metadata("design:type", String)
], UpdateCaseInternal.prototype, "quotationDocument", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        description: 'what BPM action to take',
        example: UpdateActions_1.UpdateActions.SubmitQuotation,
    }),
    (0, class_validator_1.IsIn)([
        UpdateActions_1.UpdateActions.IntermittentSaveEnrichmentForm,
        UpdateActions_1.UpdateActions.SubmitRejectReview,
        UpdateActions_1.UpdateActions.SubmitQuotation,
        UpdateActions_1.UpdateActions.SaveQuotationApproval,
        UpdateActions_1.UpdateActions.SaveQuotation,
        UpdateActions_1.UpdateActions.UploadLeaseQuotation,
        UpdateActions_1.UpdateActions.SaveLeaseApproval,
        UpdateActions_1.UpdateActions.SaveDriverApproval,
        UpdateActions_1.UpdateActions.UploadDriverQuotation,
        UpdateActions_1.UpdateActions.SaveDriverQuotation,
    ]),
    (0, class_transformer_1.Expose)({ name: 'action' }),
    tslib_1.__metadata("design:type", String)
], UpdateCaseInternal.prototype, "action", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Type)(() => DeclinedPhoto),
    (0, base_models_1.Docs)({
        description: 'Contact log for after reviewing the photos',
        example: [
            {
                type: PhotoType_1.PhotoType.FuseBox,
                reason: 'Photo is not clear',
                documentId: 'emobility*account123$12345$essent',
            },
        ],
    }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Expose)({ name: 'declined_photos' }),
    tslib_1.__metadata("design:type", Array)
], UpdateCaseInternal.prototype, "declinedPhotos", void 0);
